// 商品图片介绍
<template>
    <ul class="images">
        <img v-for="img in data" :key="img.id" :src="img.img_url">
    </ul>
</template>

<script>
export default {
  name: 'ProdImg',
  props: ['data'],
  data() {
    return {
      id: this.$route.params.id
    };
  }
};
</script>

<style lang="less">
.images {
  list-style-type: none;

  img {
    width: 100%;
    // margin-left: 8px;
    // margin-right: 8px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
</style>
